import React from 'react'
import Layout from 'src/components/layouts'
import WhoWeHelpPage from 'src/components/pages/BrandPages/WhoWeHelp'

export async function getServerSideProps() {
  return {
    props: {},
  }
}

const WhoWeHelp = () => {
  return (
    <Layout isBrandPage={true}>
      <WhoWeHelpPage />
    </Layout>
  )
}

export default WhoWeHelp
